import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { FormattedMessage, injectIntl } from 'react-intl';

export const ConfigProfiles = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      profiles: [],
      profile: null,
      loading: true,
      payments: [],
      payment: {},
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
    this.handleNew = this.handleNew.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handlePaymentNew = this.handlePaymentNew.bind(this);
    this.selectorRef = React.createRef(null);
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  selectProfile(profile) {
    this.setState(prevState => ({...prevState, profile: profile}));
  }

  selectPayment(payment) {
    this.setState(prevState => ({...prevState, payment: payment}));
  }

  handleNew() {
    this.setState(prevState => ({...prevState, profile: { id: 0, default: false, onlineReservation: true }}));
  }

  handlePaymentNew() {
    this.setState(prevState => ({...prevState, payment: { id: 0 }}));
  }

  async saveProfile(profile) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/profile`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(profile)
    });
    return await response.json();
  }

  async handleSave() {
    if (!this.state.profile.name || this.state.profile.name === '')
      return;
    const data = await this.saveProfile(this.state.profile);
    var profiles = this.state.profiles;
    for (var i = 0; i < profiles.length; i++)
    {
      if (profiles[i].id === this.state.profile?.id)
      {
        profiles[i] = this.state.profile;
        break;
      }
    }
    if (i === profiles.length)
      profiles.push(data);
    this.setState(prevState => ({...prevState, profile: data}));
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  async handleDelete(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/profile/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    var profiles = this.state.profiles.filter(d => d.id !== id);
    this.setState(prevState => ({...prevState, profiles: profiles, profile: this.state.profile?.id === id ? null : this.state.profile}));
  }

  async handlePaymentDelete(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/additionalpayment/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    var payments = this.state.payments.filter(d => d.id !== id);
    this.setState(prevState => ({...prevState, payments: payments, payment: this.state.payment?.id === id ? null : this.state.payment}));
  }

  async handlePaymentSave(payment) {
    if (!payment.name || payment.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/additionalpayment`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payment)
    });
    const data = await response.json();
    var payments = this.state.payments;
    for (var i = 0; i < payments.length; i++)
    {
      if (payments[i].id === payment.id)
      {
        payments[i] = payment;
        break;
      }
    }
    if (i === payments.length)
      payments.push(data);
    this.setState(prevState => ({...prevState, payments: payments}));
    this.selectPayment(data);
  }

  handleSetDefault(profileId) {
    var profiles = this.state.profiles;
    for (var i = 0; i < profiles.length; i++)
    {
      const def = profiles[i].id === profileId;
      if (profiles[i].default !== def) {
        profiles[i].default = def;
        this.saveProfile(profiles[i]);
      }
    }
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  async changeAssigned(payment) {
    if (!this.state.profile)
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.profile.id}/${payment.id}/payment`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    const res = await response.json();
    var profiles = this.state.profiles;
    for (var i = 0; i < profiles.length; i++)
    {
      if (profiles[i].id === this.state.profile.id) {
        if (profiles[i].additionalPayments.filter(ap => ap.additionalPayment.id === res.additionalPayment.id).length > 0) {
          profiles[i].additionalPayments = profiles[i].additionalPayments.filter(ap => ap.additionalPayment.id !== res.additionalPayment.id);
        } else {
          profiles[i].additionalPayments.push(res);
        }
      }
    }
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  async changeOptions(payment, ap, included, prepayment) {
    if (!this.state.profile || !ap)
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.profile.id}/${payment.id}/paymentoptions`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({included: included, prepayment: prepayment})
    });
    const res = await response.json();
    var profiles = this.state.profiles;
    for (var i = 0; i < profiles.length; i++)
    {
      if (profiles[i].id === this.state.profile.id) {
        profiles[i].additionalPayments = profiles[i].additionalPayments.filter(ap => ap.additionalPayment.id !== res.additionalPayment.id);
        profiles[i].additionalPayments.push(res);
      }
    }
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  renderDelete(profileId) {
    return (
      <div class="btndelete" onClick={() => this.handleDelete(profileId)}><FormattedMessage id="confirm_deletion"/></div>
    );
  }

  renderPaymentDelete(paymentId) {
    return (
      <div class="btndelete" onClick={() => this.handlePaymentDelete(paymentId)}><FormattedMessage id="confirm_deletion"/></div>
    );
  }

  renderAssigned(payment) {
    const ap = this.state.profile?.additionalPayments.filter(ap => ap.additionalPayment.id === payment.id)[0];
    return <>
      <td onClick={() => this.changeAssigned(payment)}>{ ap ? '✔' : ''}</td>
      <td onClick={() => this.changeOptions(payment, ap, !ap?.included, ap?.prepayment)}>{ap?.included ? '✔' : ''}</td>
      <td onClick={() => this.changeOptions(payment, ap, ap?.included, !ap?.prepayment)}>{ap?.prepayment ? '✔' : ''}</td>
    </>;
  }

  renderAdditionalPaymentsTable() {
    return (
      <><div class="tablediv">
        <div class="tabledivbtn">

          <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
              <tr>
                <th><FormattedMessage id="name"/></th>
                <th><FormattedMessage id="amount"/></th>
                  {this.state.profile?.id > 0 ? <>
                <th><FormattedMessage id="assigned"/></th>
                <th><FormattedMessage id="included"/></th>
                <th><FormattedMessage id="prepayment"/></th>
                  </>:<></>}
                <th><FormattedMessage id="delete"/></th>
              </tr>
            </thead>
            <tbody>
              {this.state.payments.map(payment =>
                <tr key={payment.id} onClick={() => this.selectPayment(payment)} class={this.state.payment?.id === payment.id?'react-calendar__tile--active':''}>
                  <td>{payment.name}</td>
                  <td>{payment.amount+(payment.percent?"%":"")}</td>
                  {this.state.profile?.id > 0 ? this.renderAssigned(payment) : <></>}
                  <Popup ref={this.selectorRef}
                    className="popup-book"
                    trigger={open => <td><FormattedMessage id="delete"/></td>}
                    position="bottom center"
                    closeOnDocumentClick>{() => this.renderPaymentDelete(payment.id)}</Popup>
                </tr>
              )}
            </tbody>
          </table>

        </div>
        <input style={{marginTop: "5px"}} disabled={this.state.payment?.id === 0} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "new"})} id="Button_New" onClick={this.handlePaymentNew}/>
      </div>

      {this.state.payment?.id >= 0 ? <>
        <div class="form-group">
          <label for="Input_PaymentName"><FormattedMessage id="name"/></label>
          <input class="form-control" type="text" id="Input_PaymentName" name="Input.PaymentName"
            value={this.state.payment.name !== undefined ? this.state.payment.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, payment: {...prevState.payment, name: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_PaymentAmount"><FormattedMessage id="amount"/></label>
          <input class="form-control" type="text" id="Input_PaymentAmount" name="Input.PaymentAmount"
            value={this.state.payment.amount !== undefined ? this.state.payment.amount : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, payment: {...prevState.payment, amount: val.length>0?val:null}}));}}
          />
        </div>
        <div>
          <label for="Input_PaymentPercent"><FormattedMessage id="amount_percent"/></label>
          <input class="form-check-input" type="checkbox" id="Input_PaymentPercent" name="Input.PaymentPercent"
            checked={this.state.payment.percent !== undefined ? this.state.payment.percent : false}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, payment: {...prevState.payment, percent: val}}));}}
          />
        </div>
        <div>
          <label for="Input_PaymentPerInterval"><FormattedMessage id="per_interval"/></label>
          <input class="form-check-input" type="checkbox" id="Input_PaymentPerInterval" name="Input.PaymentPerInterval"
            checked={this.state.payment.perInterval !== undefined ? this.state.payment.perInterval : false}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, payment: {...prevState.payment, perInterval: val}}));}}
          />
        </div>
        <div>
          <label for="Input_PaymentReturnable"><FormattedMessage id="returnable"/></label>
          <input class="form-check-input" type="checkbox" id="Input_PaymentReturnable" name="Input.PaymentReturnable"
            checked={this.state.payment.returnable !== undefined ? this.state.payment.returnable : false}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, payment: {...prevState.payment, returnable: val}}));}}
          />
        </div>
        <div class="tablediv">
          <input class="btn btn-primary" style={{marginTop: "5px"}} type="button" value={this.state.payment.id === 0 ? this.props.intl.formatMessage({id: "create"}) : this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={() => this.handlePaymentSave(this.state.payment)}/>
        </div>
        </> : <></>}
        
        </>
    );
  }

  renderProfilesTable() {
    return (
      <><div class="tabledivbig">
        <div class="tabledivbtn">

          <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
              <tr>
                <th><FormattedMessage id="name"/></th>
                <th><FormattedMessage id="default"/></th>
                <th><FormattedMessage id="delete"/></th>
              </tr>
            </thead>
            <tbody>
              {this.state.profiles.map(profile =>
                <tr key={profile.id} onClick={() => this.selectProfile(profile)} class={this.state.profile?.id === profile.id?'react-calendar__tile--active':''}>
                  <td>{profile.name}</td>
                  <td onClick={() => this.handleSetDefault(profile.id)}>{profile.default ? '✔' : ''}</td>
                  <Popup ref={this.selectorRef}
                    className="popup-book"
                    trigger={open => <td><FormattedMessage id="delete"/></td>}
                    position="bottom center"
                    closeOnDocumentClick>{() => this.renderDelete(profile.id)}</Popup>
                </tr>
              )}
            </tbody>
          </table>

        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" disabled={this.state.profile?.id===0} type="button" value={this.props.intl.formatMessage({id: "new"})} id="Button_New" onClick={this.handleNew}/>
        </div>
        {this.state.profile === null ? <></> :
        <><div class="form-group">
          <label for="Input_ProfileName"><FormattedMessage id="profile_name"/></label>
          <input class="form-control" type="text" id="Input_ProfileName" name="Input.ProfileName"
            value={this.state.profile.name !== undefined ? this.state.profile.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, name: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceTime"><FormattedMessage id="service_time"/></label>
          <input class="form-control" type="text" id="Input_ServiceTime" name="Input.ServiceTime"
            value={this.state.profile.serviceTime !== undefined ? this.state.profile.serviceTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, serviceTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceInterval"><FormattedMessage id="resource_service_interval"/></label>
          <input class="form-control" type="text" id="Input_ServiceInterval" name="Input.ServiceInterval"
            value={this.state.profile.serviceInterval !== undefined ? this.state.profile.serviceInterval : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, serviceInterval: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceIntervalTime"><FormattedMessage id="resource_service_length"/></label>
          <input class="form-control" type="text" id="Input_ServiceIntervalTime" name="Input.ServiceIntervalTime"
            value={this.state.profile.serviceIntervalTime !== undefined ? this.state.profile.serviceIntervalTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, serviceIntervalTime: val.length>0?val:null}}));}}
          />
        </div>
        <div>
          <label for="Input_OnlineReservation"><FormattedMessage id="online_reservation"/></label>
          <input class="form-check-input" type="checkbox" id="Input_OnlineReservation" name="Input.OnlineReservation"
            checked={this.state.profile.onlineReservation !== undefined ? this.state.profile.onlineReservation : true}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, onlineReservation: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ReadinessTime"><FormattedMessage id="before_reservation"/></label>
          <input class="form-control" type="text" id="Input_ReadinessTime" name="Input.ReadinessTime"
            value={this.state.profile.readinessTime !== undefined ? this.state.profile.readinessTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, readinessTime: val.length>0?val:null}}));}}
          />
        </div>
        <div>
          <label for="Input_Delivery"><FormattedMessage id="delivary_possible"/></label>
          <input class="form-check-input" type="checkbox" id="Input_Delivery" name="Input.Delivery"
            checked={this.state.profile.delivery !== undefined && this.state.profile.delivery !== null}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, delivery: val ? false : null}}));}}
          />
        </div>
        <div>
          <label for="Input_OnlyDelivery"><FormattedMessage id="only_delivery"/></label>
          <input class="form-check-input" type="checkbox" id="Input_OnlyDelivery" name="Input.OnlyDelivery"
            checked={this.state.profile.delivery === true}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, delivery: val}}));}}
          />
        </div>
        {this.state.profile.delivery === false ?
        <div>
          <label for="Input_DeliveryOneDirection"><FormattedMessage id="delivery_one_direction"/></label>
          <input class="form-check-input" type="checkbox" id="Input_DeliveryOneDirection" name="Input.DeliveryOneDirection"
            checked={this.state.profile.deliveryOneDirection === true}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, deliveryOneDirection: val}}));}}
          />
        </div> : <></>}
        <div class="form-group">
          <label for="Input_MaxDeliveryDistance"><FormattedMessage id="delivery_distance"/></label>
          <input class="form-control" type="text" id="Input_MaxDeliveryDistance" name="Input.MaxDeliveryDistance"
            value={this.state.profile.maxDeliveryDistance !== undefined ? this.state.profile.maxDeliveryDistance : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, maxDeliveryDistance: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_DeliveryType"><FormattedMessage id="delivery_time"/></label>
          <select class="form-control" id="Input_DeliveryType" name="Input.DeliveryType"
            value={this.state.profile.deliveryType ? this.state.profile.deliveryType.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, deliveryType: val.length>0?val:null}}));}}>
              <option value=""></option>
              <option value="1"><FormattedMessage id="distance_calc_type"/> 1</option>
              <option value="2"><FormattedMessage id="distance_calc_type"/> 2</option>
              <option value="3"><FormattedMessage id="distance_calc_fixed"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_DeliveryBillingTime"><FormattedMessage id="delivery_billing_time"/></label>
          <input class="form-control" type="text" id="Input_DeliveryBillingTime" name="Input.DeliveryBillingTime"
            value={this.state.profile.deliveryBillingTime !== undefined ? this.state.profile.deliveryBillingTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, deliveryBillingTime: val.length>0?val:null}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_BookingAllignment"><FormattedMessage id="next_reservation"/></label>
          <select class="form-control" id="Input_BookingAllignment" name="Input.BookingAllignment"
            value={this.state.profile.bookingAllignment ? this.state.profile.bookingAllignment.toString() : '3'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, bookingAllignment: val}}));}}>
              <option value="1"><FormattedMessage id="next_reservation_month"/></option>
              <option value="2"><FormattedMessage id="next_reservation_day"/></option>
              <option value="3"><FormattedMessage id="next_reservation_hour"/></option>
              <option value="4"><FormattedMessage id="next_reservation_30min"/></option>
              <option value="5"><FormattedMessage id="next_reservation_15min"/></option>
              <option value="6"><FormattedMessage id="next_reservation_5min"/></option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ExtendTime"><FormattedMessage id="booking_extendable"/></label>
          <select class="form-control" id="Input_ExtendTime" name="Input.ExtendTime"
            value={this.state.profile.extendType ? this.state.profile.extendType.toString() : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, extendType: val}}));}}>
              <option value="1"><FormattedMessage id="booking_extendable_no"/></option>
              <option value="2"><FormattedMessage id="booking_extendable_days"/></option>
              <option value="3"><FormattedMessage id="booking_extendable_hours"/></option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_PriceInterval"><FormattedMessage id="price_interval"/></label>
          <select class="form-control" id="Input_PriceInterval" name="Input.PriceInterval"
            value={this.state.profile.priceInterval ? this.state.profile.priceInterval.toString() : '2'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, priceInterval: val}}));}}>
              <option value="1"><FormattedMessage id="booking_extendable_days"/></option>
              <option value="2"><FormattedMessage id="booking_extendable_hours"/></option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_FirstPrice"><FormattedMessage id="first_interval_price"/></label>
          <input class="form-control" type="text" id="Input_FirstPrice" name="Input.FirstPrice"
            value={this.state.profile.firstIntervalPrice !== undefined ? this.state.profile.firstIntervalPrice : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, firstIntervalPrice: val.length>0?val:null}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_FirstPriceIntervals"><FormattedMessage id="first_interval_price_length"/></label>
          <input class="form-control" type="text" id="Input_FirstPriceIntervals" name="Input.FirstPriceIntervals"
            value={this.state.profile.firstIntervalPriceIntervals !== undefined ? this.state.profile.firstIntervalPriceIntervals : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, firstIntervalPriceIntervals: val.length>0?val:null}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_DeliveryPrice"><FormattedMessage id="delivery_price"/></label>
          <input class="form-control" type="text" id="Input_DeliveryPrice" name="Input.DeliveryPrice"
            value={this.state.profile.deliveryPrice !== undefined ? this.state.profile.deliveryPrice : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, deliveryPrice: val.length>0?val:null}}));}}
          />
        </div>

        <div class="tablediv">
          <input class="btn btn-primary" style={{marginTop: "5px"}} type="button" value={this.state.profile.id === 0 ? this.props.intl.formatMessage({id: "create"}) : this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={this.handleSave}/>
        </div>
        </>}
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderProfilesTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="params" />
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="booking_profiles"/></h4></div>
        <div><FormattedMessage id="profiles_list"/></div>
        {contents}
        <div><FormattedMessage id="taxes"/></div>
        {this.renderAdditionalPaymentsTable()}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateProfilesData(ownCompanies[0].id);
        this.populatePaymentsData(ownCompanies[0].id);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }

  async populatePaymentsData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/additionalpayments`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, payments: data, loading: false}));
  }
})